<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth">Age Filter</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_filter.Age"
              placeholder="Age"
              type="text"
              autocomplete="off"
              id="Age"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth">Income Filter</b-input-group-text>
            </b-input-group-prepend>
            <!-- <b-form-input
              v-model.lazy="current_filter.Income"
              placeholder="Income"
              type="text"
              autocomplete="off"
              id="Income"
              @change.native="saveField"
            ></b-form-input>-->
            <b-form-select class="dropdown" v-model="current_filter.Income">
              <option value></option>
              <option v-for="_if in seminar.income_filters" :key="_if" :value="_if">{{ _if }}</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth">Dwelling Filter</b-input-group-text>
            </b-input-group-prepend>
            <!-- <b-form-input
              v-model.lazy="current_filter.Dwelling"
              placeholder="Dwelling"
              type="text"
              autocomplete="off"
              id="Dwelling"
              @change.native="saveField"
            ></b-form-input>-->
            <b-form-select class="dropdown" v-model="current_filter.Dwelling">
              <option value></option>
              <option v-for="_df in seminar.dwelling_filters" :key="_df" :value="_df">{{ _df }}</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth">Ethnicity Filter</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_filter.Ethnicity"
              placeholder="Ethnicity"
              type="text"
              autocomplete="off"
              id="Ethnicity"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidth">Other Filter</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model.lazy="current_filter.Other"
              placeholder="Other"
              type="text"
              autocomplete="off"
              id="Other"
              @change.native="saveField"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <i
          v-if="this.current_seminar.Filters.length>1"
          v-b-tooltip
          title="Delete Filter Group"
          class="fa fa-trash fa-lg mt-2 pt-1 clickIcon"
          @click="deleteFilter"
        ></i>
      </b-col>
    </b-row>

    <hr />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  name: "FilterRow",
  components: {
    StyledDialog,
  },
  props: {
    filter_object: { type: Object },
    seminar_object: { type: Object },
  },
  data() {
    return {
      current_filter: this.filter_object,
      current_seminar: this.seminar_object,
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false,
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    deleteFilter() {
      this.$emit("RemoveFilter", this.current_filter);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      // this.$v.$touch();
      // if (this.$v.$error) {
      //   this.dismiss2CountDown = this.dismiss2Secs;
      // } else {
      //   this.$store
      //     .dispatch("dealership/Save", {
      //       client: this.$store.state.seminar.restaurant_edit,
      //       fields: this.dirtyFields
      //     })
      //     .then(
      //       (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
      //     );
      // }
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );
      }
    },
    saveField: function (event) {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        FilterID: this.current_filter.FilterID,
        FieldToSet: event.target.id,
        ValueToSet: event.target.value,
      };

      this.$store
        .dispatch("seminar/SaveFilter", _operation)
        .then
        //this.current_seating.SeatingID = this.saveField(_event);
        ();
    },
    saveFieldWatch: function (_operation) {
      this.$store
        .dispatch("seminar/SaveFilter", _operation)
        .then
        //this.current_seating.SeatingID = this.saveField(_event);
        ();
    },
    addDirtyField: function (event) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value,
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function (field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue,
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldSwitch: function (event) {
      this.dirtyFields = this.dirtyFields.filter(
        (dirtyField) => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString(),
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
  },
  computed: {
    ...mapState(["seminar", "territory", "n_user"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
  },
  created() {
    if (this.current_filter.FilterID === -1) {
      this.$store
        .dispatch("seminar/AddFilter", this.current_filter)
        .then((response) => {
          this.current_filter.FilterID = response.data["AddFilterResult"];
          //console.log(this.current_filter.FilterID);
        })
        .then(
          this.$store
            .dispatch("seminar/RefreshZips", this.current_seminar.SeminarID)
            .then((response) => {
              this.$store.state.seminar.seminar_edit.Zips =
                response.data["RefreshZipsResult"];
            })
        );
    }
  },
  watch: {
    "current_filter.Income": function () {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        FilterID: this.current_filter.FilterID,
        FieldToSet: "Income",
        ValueToSet: this.current_filter.Income,
      };
      this.saveFieldWatch(_operation);
    },
    "current_filter.Dwelling": function () {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        FilterID: this.current_filter.FilterID,
        FieldToSet: "Dwelling",
        ValueToSet: this.current_filter.Dwelling,
      };
      this.saveFieldWatch(_operation);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
hr {
  border: none;
  border-top: 1px dotted #333;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>
